var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-bot",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.14,
    height: 37.14,
    viewBox: "0 0 37.14 37.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.177,
    y1: 1,
    x2: 0.748,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9118be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ab79"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat-bot-2",
    "data-name": "chat-bot",
    d: "M14.923,18.2V16.017a1.092,1.092,0,0,1,2.185,0V18.2a1.092,1.092,0,0,1-2.185,0Zm25.257-.319A3.3,3.3,0,0,1,41.14,20.2V31.5a3.3,3.3,0,0,1-.959,2.316l-2,2a3.3,3.3,0,0,1-2.316.959H32.4v3.277a1.092,1.092,0,0,1-1.7.909l-6.279-4.186H18.013a3.3,3.3,0,0,1-2.316-.959l-.913-.913-2.532,1.689a1.092,1.092,0,0,1-1.7-.909V32.4H9.274a3.3,3.3,0,0,1-2.316-.959l-2-2A3.3,3.3,0,0,1,4,27.128V13.644a3.3,3.3,0,0,1,.959-2.316l2-2A3.3,3.3,0,0,1,9.274,8.37h8.474l-2.506-2.5A1.094,1.094,0,0,1,16.789,4.32l3.6,3.6,3.6-3.6a1.094,1.094,0,0,1,1.547,1.547l-2.506,2.5H31.5a3.3,3.3,0,0,1,2.316.959l2,2a3.3,3.3,0,0,1,.959,2.316v1.44a3.2,3.2,0,0,1,1.411.8ZM17.6,30.4a1.092,1.092,0,0,1,.605-.184H31.5a1.092,1.092,0,0,0,.771-.319l2-2a1.092,1.092,0,0,0,.319-.771V13.644a1.092,1.092,0,0,0-.319-.771l-2-2a1.092,1.092,0,0,0-.771-.319H9.274a1.092,1.092,0,0,0-.771.319l-2,2a1.092,1.092,0,0,0-.319.771V27.128A1.092,1.092,0,0,0,6.5,27.9l2,2a1.092,1.092,0,0,0,.771.319h2.373a1.092,1.092,0,0,1,1.092,1.092v2.327Zm21.36-10.2a1.092,1.092,0,0,0-.319-.771L36.77,17.561v9.567a3.3,3.3,0,0,1-.959,2.316l-2,2A3.3,3.3,0,0,1,31.5,32.4H18.53l-1.892,1.263.6.6a1.092,1.092,0,0,0,.771.319h6.742a1.092,1.092,0,0,1,.605.184l4.857,3.236V35.679a1.092,1.092,0,0,1,1.092-1.092h4.557a1.092,1.092,0,0,0,.771-.319l2-2a1.092,1.092,0,0,0,.319-.771ZM25.528,25.529l1.092-1.092a1.094,1.094,0,1,0-1.547-1.547l-.771.773H16.468L15.7,22.89a1.094,1.094,0,1,0-1.547,1.547l1.092,1.092a1.092,1.092,0,0,0,.773.319h8.739A1.092,1.092,0,0,0,25.528,25.529Zm-.773-6.235A1.092,1.092,0,0,0,25.847,18.2V16.017a1.092,1.092,0,1,0-2.185,0V18.2A1.092,1.092,0,0,0,24.755,19.294Z",
    transform: "translate(-4 -3.999)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chat-bot.55fede28da6ac7c3ec6b3951d960019e.svg";
export { ForwardRef as ReactComponent };